module.exports = __webpack_public_path__ + "static/media/JuradosImage.56eb3f79.webp";